import { Box } from "@mui/material";

export default function ({ num }) {
  return <Box className="circled-number">{num}</Box>;
} 
